__turbopack_context__.v({
  "actionIcon": "advanced-mega-menu-header-module__Tg31uq__actionIcon",
  "ammhItemIn": "advanced-mega-menu-header-module__Tg31uq__ammhItemIn",
  "brandCluster": "advanced-mega-menu-header-module__Tg31uq__brandCluster",
  "bubble": "advanced-mega-menu-header-module__Tg31uq__bubble",
  "bubbleMegaOpen": "advanced-mega-menu-header-module__Tg31uq__bubbleMegaOpen",
  "bubbleOpen": "advanced-mega-menu-header-module__Tg31uq__bubbleOpen",
  "col": "advanced-mega-menu-header-module__Tg31uq__col",
  "contact": "advanced-mega-menu-header-module__Tg31uq__contact",
  "ctaLabel": "advanced-mega-menu-header-module__Tg31uq__ctaLabel",
  "ctaSwipe": "advanced-mega-menu-header-module__Tg31uq__ctaSwipe",
  "ctaWrap": "advanced-mega-menu-header-module__Tg31uq__ctaWrap",
  "drawer": "advanced-mega-menu-header-module__Tg31uq__drawer",
  "drawerAccordionBtn": "advanced-mega-menu-header-module__Tg31uq__drawerAccordionBtn",
  "drawerAccordionBtnLabel": "advanced-mega-menu-header-module__Tg31uq__drawerAccordionBtnLabel",
  "drawerAccordionPanel": "advanced-mega-menu-header-module__Tg31uq__drawerAccordionPanel",
  "drawerAccordionPanelOpen": "advanced-mega-menu-header-module__Tg31uq__drawerAccordionPanelOpen",
  "drawerBackdrop": "advanced-mega-menu-header-module__Tg31uq__drawerBackdrop",
  "drawerBackdropVisible": "advanced-mega-menu-header-module__Tg31uq__drawerBackdropVisible",
  "drawerChevron": "advanced-mega-menu-header-module__Tg31uq__drawerChevron",
  "drawerChevronOpen": "advanced-mega-menu-header-module__Tg31uq__drawerChevronOpen",
  "drawerClose": "advanced-mega-menu-header-module__Tg31uq__drawerClose",
  "drawerCol": "advanced-mega-menu-header-module__Tg31uq__drawerCol",
  "drawerFooter": "advanced-mega-menu-header-module__Tg31uq__drawerFooter",
  "drawerFooterActions": "advanced-mega-menu-header-module__Tg31uq__drawerFooterActions",
  "drawerFooterRow": "advanced-mega-menu-header-module__Tg31uq__drawerFooterRow",
  "drawerHeader": "advanced-mega-menu-header-module__Tg31uq__drawerHeader",
  "drawerInlineActions": "advanced-mega-menu-header-module__Tg31uq__drawerInlineActions",
  "drawerLead": "advanced-mega-menu-header-module__Tg31uq__drawerLead",
  "drawerLink": "advanced-mega-menu-header-module__Tg31uq__drawerLink",
  "drawerMegaGridMobile": "advanced-mega-menu-header-module__Tg31uq__drawerMegaGridMobile",
  "drawerMegaGridTablet": "advanced-mega-menu-header-module__Tg31uq__drawerMegaGridTablet",
  "drawerMegaStack": "advanced-mega-menu-header-module__Tg31uq__drawerMegaStack",
  "drawerNav": "advanced-mega-menu-header-module__Tg31uq__drawerNav",
  "drawerNavItem": "advanced-mega-menu-header-module__Tg31uq__drawerNavItem",
  "drawerNavList": "advanced-mega-menu-header-module__Tg31uq__drawerNavList",
  "drawerOpen": "advanced-mega-menu-header-module__Tg31uq__drawerOpen",
  "drawerTitle": "advanced-mega-menu-header-module__Tg31uq__drawerTitle",
  "group": "advanced-mega-menu-header-module__Tg31uq__group",
  "groupTitle": "advanced-mega-menu-header-module__Tg31uq__groupTitle",
  "langBtn": "advanced-mega-menu-header-module__Tg31uq__langBtn",
  "langBtnText": "advanced-mega-menu-header-module__Tg31uq__langBtnText",
  "langDd": "advanced-mega-menu-header-module__Tg31uq__langDd",
  "langGlobe": "advanced-mega-menu-header-module__Tg31uq__langGlobe",
  "langItem": "advanced-mega-menu-header-module__Tg31uq__langItem",
  "langItemCurrent": "advanced-mega-menu-header-module__Tg31uq__langItemCurrent",
  "langItemCurrentHint": "advanced-mega-menu-header-module__Tg31uq__langItemCurrentHint",
  "langItemFlag": "advanced-mega-menu-header-module__Tg31uq__langItemFlag",
  "langOptionWrap": "advanced-mega-menu-header-module__Tg31uq__langOptionWrap",
  "langWrap": "advanced-mega-menu-header-module__Tg31uq__langWrap",
  "langWrapOpen": "advanced-mega-menu-header-module__Tg31uq__langWrapOpen",
  "link": "advanced-mega-menu-header-module__Tg31uq__link",
  "linkArrow": "advanced-mega-menu-header-module__Tg31uq__linkArrow",
  "linkBody": "advanced-mega-menu-header-module__Tg31uq__linkBody",
  "linkDescription": "advanced-mega-menu-header-module__Tg31uq__linkDescription",
  "linkItem": "advanced-mega-menu-header-module__Tg31uq__linkItem",
  "linkList": "advanced-mega-menu-header-module__Tg31uq__linkList",
  "linkText": "advanced-mega-menu-header-module__Tg31uq__linkText",
  "logo": "advanced-mega-menu-header-module__Tg31uq__logo",
  "logoImg": "advanced-mega-menu-header-module__Tg31uq__logoImg",
  "logoImgFaded": "advanced-mega-menu-header-module__Tg31uq__logoImgFaded",
  "logoImgOverlay": "advanced-mega-menu-header-module__Tg31uq__logoImgOverlay",
  "logoImgOverlayVisible": "advanced-mega-menu-header-module__Tg31uq__logoImgOverlayVisible",
  "logoImgWrap": "advanced-mega-menu-header-module__Tg31uq__logoImgWrap",
  "mega": "advanced-mega-menu-header-module__Tg31uq__mega",
  "megaDesktop": "advanced-mega-menu-header-module__Tg31uq__megaDesktop",
  "megaFooterLabel": "advanced-mega-menu-header-module__Tg31uq__megaFooterLabel",
  "megaFooterPill": "advanced-mega-menu-header-module__Tg31uq__megaFooterPill",
  "megaFooterPills": "advanced-mega-menu-header-module__Tg31uq__megaFooterPills",
  "megaFooterRow": "advanced-mega-menu-header-module__Tg31uq__megaFooterRow",
  "megaInner": "advanced-mega-menu-header-module__Tg31uq__megaInner",
  "megaInnerStretch": "advanced-mega-menu-header-module__Tg31uq__megaInnerStretch",
  "megaPanelContent": "advanced-mega-menu-header-module__Tg31uq__megaPanelContent",
  "megaVisible": "advanced-mega-menu-header-module__Tg31uq__megaVisible",
  "menuToggle": "advanced-mega-menu-header-module__Tg31uq__menuToggle",
  "menuToggleBar": "advanced-mega-menu-header-module__Tg31uq__menuToggleBar",
  "menuToggleBarOpen": "advanced-mega-menu-header-module__Tg31uq__menuToggleBarOpen",
  "menuToggleBarOpenBot": "advanced-mega-menu-header-module__Tg31uq__menuToggleBarOpenBot",
  "menuToggleBarOpenMid": "advanced-mega-menu-header-module__Tg31uq__menuToggleBarOpenMid",
  "navBtn": "advanced-mega-menu-header-module__Tg31uq__navBtn",
  "navBtnActive": "advanced-mega-menu-header-module__Tg31uq__navBtnActive",
  "navBtnLabel": "advanced-mega-menu-header-module__Tg31uq__navBtnLabel",
  "navChevron": "advanced-mega-menu-header-module__Tg31uq__navChevron",
  "navDesktop": "advanced-mega-menu-header-module__Tg31uq__navDesktop",
  "navIcon": "advanced-mega-menu-header-module__Tg31uq__navIcon",
  "pill": "advanced-mega-menu-header-module__Tg31uq__pill",
  "promo": "advanced-mega-menu-header-module__Tg31uq__promo",
  "promoBg": "advanced-mega-menu-header-module__Tg31uq__promoBg",
  "promoCta": "advanced-mega-menu-header-module__Tg31uq__promoCta",
  "promoCtaBtn": "advanced-mega-menu-header-module__Tg31uq__promoCtaBtn",
  "promoCtaBtnLink": "advanced-mega-menu-header-module__Tg31uq__promoCtaBtnLink",
  "promoCtaBtnSecondary": "advanced-mega-menu-header-module__Tg31uq__promoCtaBtnSecondary",
  "promoCtaRow": "advanced-mega-menu-header-module__Tg31uq__promoCtaRow",
  "promoHtml": "advanced-mega-menu-header-module__Tg31uq__promoHtml",
  "promoImage": "advanced-mega-menu-header-module__Tg31uq__promoImage",
  "promoStack": "advanced-mega-menu-header-module__Tg31uq__promoStack",
  "promoTag": "advanced-mega-menu-header-module__Tg31uq__promoTag",
  "promoTitle": "advanced-mega-menu-header-module__Tg31uq__promoTitle",
  "replicaAcc": "advanced-mega-menu-header-module__Tg31uq__replicaAcc",
  "replicaAccBody": "advanced-mega-menu-header-module__Tg31uq__replicaAccBody",
  "replicaAccOpen": "advanced-mega-menu-header-module__Tg31uq__replicaAccOpen",
  "replicaActions": "advanced-mega-menu-header-module__Tg31uq__replicaActions",
  "replicaBar": "advanced-mega-menu-header-module__Tg31uq__replicaBar",
  "replicaBarInner": "advanced-mega-menu-header-module__Tg31uq__replicaBarInner",
  "replicaBrand": "advanced-mega-menu-header-module__Tg31uq__replicaBrand",
  "replicaBrandDot": "advanced-mega-menu-header-module__Tg31uq__replicaBrandDot",
  "replicaBrandDotFill": "advanced-mega-menu-header-module__Tg31uq__replicaBrandDotFill",
  "replicaBrandDots": "advanced-mega-menu-header-module__Tg31uq__replicaBrandDots",
  "replicaBrandNav": "advanced-mega-menu-header-module__Tg31uq__replicaBrandNav",
  "replicaBtn": "advanced-mega-menu-header-module__Tg31uq__replicaBtn",
  "replicaBtnGhost": "advanced-mega-menu-header-module__Tg31uq__replicaBtnGhost",
  "replicaBtnPrimary": "advanced-mega-menu-header-module__Tg31uq__replicaBtnPrimary",
  "replicaBtnSm": "advanced-mega-menu-header-module__Tg31uq__replicaBtnSm",
  "replicaBurger": "advanced-mega-menu-header-module__Tg31uq__replicaBurger",
  "replicaCtas": "advanced-mega-menu-header-module__Tg31uq__replicaCtas",
  "replicaDeadlines": "advanced-mega-menu-header-module__Tg31uq__replicaDeadlines",
  "replicaDl": "advanced-mega-menu-header-module__Tg31uq__replicaDl",
  "replicaDlCnt": "advanced-mega-menu-header-module__Tg31uq__replicaDlCnt",
  "replicaDlCntSoon": "advanced-mega-menu-header-module__Tg31uq__replicaDlCntSoon",
  "replicaDrawer": "advanced-mega-menu-header-module__Tg31uq__replicaDrawer",
  "replicaDrawerOpen": "advanced-mega-menu-header-module__Tg31uq__replicaDrawerOpen",
  "replicaFeat": "advanced-mega-menu-header-module__Tg31uq__replicaFeat",
  "replicaFeatLbl": "advanced-mega-menu-header-module__Tg31uq__replicaFeatLbl",
  "replicaFill": "advanced-mega-menu-header-module__Tg31uq__replicaFill",
  "replicaFlipIn": "advanced-mega-menu-header-module__Tg31uq__replicaFlipIn",
  "replicaFlipOut": "advanced-mega-menu-header-module__Tg31uq__replicaFlipOut",
  "replicaGrp": "advanced-mega-menu-header-module__Tg31uq__replicaGrp",
  "replicaIconBtn": "advanced-mega-menu-header-module__Tg31uq__replicaIconBtn",
  "replicaKbd": "advanced-mega-menu-header-module__Tg31uq__replicaKbd",
  "replicaLogoCard": "advanced-mega-menu-header-module__Tg31uq__replicaLogoCard",
  "replicaLogoCardIn": "advanced-mega-menu-header-module__Tg31uq__replicaLogoCardIn",
  "replicaLogoCardOut": "advanced-mega-menu-header-module__Tg31uq__replicaLogoCardOut",
  "replicaLogoName": "advanced-mega-menu-header-module__Tg31uq__replicaLogoName",
  "replicaLogoNameSerif": "advanced-mega-menu-header-module__Tg31uq__replicaLogoNameSerif",
  "replicaLogoStage": "advanced-mega-menu-header-module__Tg31uq__replicaLogoStage",
  "replicaLogoTag": "advanced-mega-menu-header-module__Tg31uq__replicaLogoTag",
  "replicaLogoWords": "advanced-mega-menu-header-module__Tg31uq__replicaLogoWords",
  "replicaMark": "advanced-mega-menu-header-module__Tg31uq__replicaMark",
  "replicaMarkSerif": "advanced-mega-menu-header-module__Tg31uq__replicaMarkSerif",
  "replicaMega": "advanced-mega-menu-header-module__Tg31uq__replicaMega",
  "replicaMegaOpen": "advanced-mega-menu-header-module__Tg31uq__replicaMegaOpen",
  "replicaMore": "advanced-mega-menu-header-module__Tg31uq__replicaMore",
  "replicaNav": "advanced-mega-menu-header-module__Tg31uq__replicaNav",
  "replicaNavCount": "advanced-mega-menu-header-module__Tg31uq__replicaNavCount",
  "replicaNavHasActive": "advanced-mega-menu-header-module__Tg31uq__replicaNavHasActive",
  "replicaNavInd": "advanced-mega-menu-header-module__Tg31uq__replicaNavInd",
  "replicaNavItem": "advanced-mega-menu-header-module__Tg31uq__replicaNavItem",
  "replicaPanelFoot": "advanced-mega-menu-header-module__Tg31uq__replicaPanelFoot",
  "replicaPanelFootLinks": "advanced-mega-menu-header-module__Tg31uq__replicaPanelFootLinks",
  "replicaPg": "advanced-mega-menu-header-module__Tg31uq__replicaPg",
  "replicaPgCompany": "advanced-mega-menu-header-module__Tg31uq__replicaPgCompany",
  "replicaPgDense": "advanced-mega-menu-header-module__Tg31uq__replicaPgDense",
  "replicaPgProducts": "advanced-mega-menu-header-module__Tg31uq__replicaPgProducts",
  "replicaPgResources": "advanced-mega-menu-header-module__Tg31uq__replicaPgResources",
  "replicaProd": "advanced-mega-menu-header-module__Tg31uq__replicaProd",
  "replicaProdFoot": "advanced-mega-menu-header-module__Tg31uq__replicaProdFoot",
  "replicaProdHead": "advanced-mega-menu-header-module__Tg31uq__replicaProdHead",
  "replicaRegion": "advanced-mega-menu-header-module__Tg31uq__replicaRegion",
  "replicaRegionBtn": "advanced-mega-menu-header-module__Tg31uq__replicaRegionBtn",
  "replicaRegionCode": "advanced-mega-menu-header-module__Tg31uq__replicaRegionCode",
  "replicaRegionList": "advanced-mega-menu-header-module__Tg31uq__replicaRegionList",
  "replicaRegionPop": "advanced-mega-menu-header-module__Tg31uq__replicaRegionPop",
  "replicaRegionPopOpen": "advanced-mega-menu-header-module__Tg31uq__replicaRegionPopOpen",
  "replicaRoot": "advanced-mega-menu-header-module__Tg31uq__replicaRoot",
  "replicaRootCompact": "advanced-mega-menu-header-module__Tg31uq__replicaRootCompact",
  "replicaRootRetracted": "advanced-mega-menu-header-module__Tg31uq__replicaRootRetracted",
  "replicaRootSticky": "advanced-mega-menu-header-module__Tg31uq__replicaRootSticky",
  "replicaScrim": "advanced-mega-menu-header-module__Tg31uq__replicaScrim",
  "replicaSearch": "advanced-mega-menu-header-module__Tg31uq__replicaSearch",
  "replicaSearchBox": "advanced-mega-menu-header-module__Tg31uq__replicaSearchBox",
  "replicaSearchEmpty": "advanced-mega-menu-header-module__Tg31uq__replicaSearchEmpty",
  "replicaSearchIn": "advanced-mega-menu-header-module__Tg31uq__replicaSearchIn",
  "replicaSearchOpen": "advanced-mega-menu-header-module__Tg31uq__replicaSearchOpen",
  "replicaSearchRes": "advanced-mega-menu-header-module__Tg31uq__replicaSearchRes",
  "replicaSheet": "advanced-mega-menu-header-module__Tg31uq__replicaSheet",
  "replicaStatus": "advanced-mega-menu-header-module__Tg31uq__replicaStatus",
  "replicaStatusDot": "advanced-mega-menu-header-module__Tg31uq__replicaStatusDot",
  "replicaTag": "advanced-mega-menu-header-module__Tg31uq__replicaTag",
  "replicaTagMuted": "advanced-mega-menu-header-module__Tg31uq__replicaTagMuted",
  "replicaTicker": "advanced-mega-menu-header-module__Tg31uq__replicaTicker",
  "replicaTickerDot": "advanced-mega-menu-header-module__Tg31uq__replicaTickerDot",
  "replicaUtil": "advanced-mega-menu-header-module__Tg31uq__replicaUtil",
  "replicaUtilInner": "advanced-mega-menu-header-module__Tg31uq__replicaUtilInner",
  "replicaUtilRight": "advanced-mega-menu-header-module__Tg31uq__replicaUtilRight",
  "replicaWrap": "advanced-mega-menu-header-module__Tg31uq__replicaWrap",
  "rightDesktop": "advanced-mega-menu-header-module__Tg31uq__rightDesktop",
  "root": "advanced-mega-menu-header-module__Tg31uq__root",
  "rootRetracted": "advanced-mega-menu-header-module__Tg31uq__rootRetracted",
  "rootSticky": "advanced-mega-menu-header-module__Tg31uq__rootSticky",
  "rootStuck": "advanced-mega-menu-header-module__Tg31uq__rootStuck",
  "topbar": "advanced-mega-menu-header-module__Tg31uq__topbar",
  "topbarInner": "advanced-mega-menu-header-module__Tg31uq__topbarInner",
});
